var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckmarked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M437.019 74.98C388.667 26.629 324.38 0 256 0C187.619 0 123.332 26.629 74.98 74.98C26.629 123.332 0 187.62 0 256C0 324.38 26.629 388.667 74.98 437.019C123.332 485.371 187.62 512 256 512C324.38 512 388.667 485.371 437.019 437.02C485.371 388.667 512 324.38 512 256C512 187.62 485.371 123.333 437.019 74.98ZM378.306 195.073L235.241 338.139C232.312 341.068 228.473 342.532 224.635 342.532C220.796 342.532 216.957 341.068 214.028 338.139L133.694 257.806C127.836 251.949 127.836 242.452 133.694 236.593C139.551 230.735 149.049 230.735 154.907 236.593L224.635 306.32L357.093 173.86C362.95 168.002 372.448 168.002 378.306 173.86C384.164 179.718 384.164 189.215 378.306 195.073Z",
    fill: "#22BB4C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmarked);
export default __webpack_public_path__ + "static/media/checkmarked.f60bb7b8be5b561ef42f0ea1144f3228.svg";
export { ForwardRef as ReactComponent };